<template>
 <div id="app">
    <router-view />
  </div>
</template>

<script>
'use strict';
import '@/style/reset.styl'; 
import '@/style/common.styl'; 
import { isLogin } from '@act-lib/js-bridge';
export default {
 data() {
  return {

  };
 },
 methods: {

 },
 beforeCreate() {
   setTimeout(() => {
      let ss = window.sessionStorage;
      if (isLogin()) {
          if (ss.getItem('unlogin') === '1') {
              ss.setItem('unlogin', '2');
          }
      } else {
          ss.setItem('unlogin', '1');
      }
    }, 300);
    // jumpPath注入 根据类型选择跳转方式
    window.jumpPath = (jumpInfo) => {
        switch (jumpInfo.type) {
            case 'pushRouter': // 切换路由
                this.$router.push(jumpInfo.url);
                break;
            default:
                break;
        }
    };
  },
  mounted(){
    this.$router.beforeEach((to, from, next) => {
      if(from.name === 'home') {
          document.body.style.overflow = 'scroll';
      }
      next();
    });
  }
};
</script>

<style lang="stylus">
#app {
    margin: 0 auto;
    max-width: 1080px;
}
/* 正常手机 */
@media screen and (max-width: 500px) {
    #app {
        position: relative;
        z-index: 5;
        width: 100%;
        height: 100%;
    }
}
 .page {
    position: relative;
    z-index: 5;
    width: 100%;
    height: 100%;
}

</style>
